<template>
    <c-dialog ref="dialog" mode="slide" width="75vw" enable-flex mask-close @resolve="editHandle">
        <m-search ref="search" @search="searchHandle">
            <m-search-item label="背贴码">
                <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
            </m-search-item>
            <m-search-item label="IMEI码">
                <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
            </m-search-item>
            <m-search-item label="支付渠道">
                <c-select :options="CHECK_PAYMENT_CHANNEL" name="check_payment_channel" placeholder="请选择追番渠道"></c-select>
            </m-search-item>
            <m-search-item label="品牌">
                <c-input name="brand_name"></c-input>
            </m-search-item>
            <m-search-item label="型号">
                <c-input name="model_name"></c-input>
            </m-search-item>
        </m-search>
        <c-table ref="productList">
            <c-table-column type="selector" width="32"></c-table-column>
            <c-table-column label="支付渠道"  width="120">
                <template #default="{data}">
                    <c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="data.check_payment_channel"></c-state>
                </template>
            </c-table-column>
            <c-table-column
                        label="商品信息"
                        width="230"
                >
                    <template #default="{data}">
                        {{getProductText(data)}}
                    </template>
            </c-table-column>
            <c-table-column
                    name="produce_unique_code"
                    label="背贴码"
                    width="130"
            >
            </c-table-column>
            <c-table-column
                    name="produce_imei"
                    label="IMEI"
                    width="130"
            >
            </c-table-column>
            <c-table-column
                    name="order_no"
                    label="小黑订单号"
                    width="130"
            >
            </c-table-column>
            <c-table-column label="销售货款" width="100">
                <template #default="{data}">
                    <span style="color: green">￥{{data.check_product_money||0}}</span>
                </template>
            </c-table-column>
            <c-table-column label="退款金额" width="100">
                <template #default="{data}">
                    <span style="color: red">￥{{data.check_return_money||0}}</span>
                </template>
            </c-table-column>
            <c-table-column label="补差金额" width="100">
                <template #default="{data}">
                    <span style="color: red">￥{{data.check_supplement_money||0}}</span>
                </template>
            </c-table-column>
            <c-table-column label="结算金额" width="100">
                <template #default="{data}">
                    <strong v-if="data.check_receipt_money > 0" style="color: green">￥{{data.check_receipt_money||0}}</strong>
                    <strong v-if="data.check_receipt_money <= 0" style="color: red">￥{{data.check_receipt_money||0}}</strong>
                </template>
            </c-table-column>
            <c-table-column
                    name="order_create_date"
                    label="下单日期"
                    width="130"
            >
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
import {asyncMapState} from '@/store'

export default {
    name: 'cashWithdrawApply',

    components: {
    },
    computed: {
        // 获取dictName选项数据
        ...asyncMapState(['CHECK_PAYMENT_CHANNEL'])
    },
    props: {
        withdraw_account_type: [String, Number]
    },

    data() {
        return {
            ids:[],                 //提现明细ID
            check_payment_channel:0, //支付渠道
            orderCount:0,           //提现订单数
            withdrawAmount:0        //提现总额（分）
        }
    },

    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            this.$refs.productList.load({
                url: '/withdraw/operable/order/list',
                data
            });
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },
        //检验参数
        validatePaymentChannel(list) {
            // 取第一个作为基准值
            this.check_payment_channel = list[0].check_payment_channel;
            const validList = list;
            if (validList.length <= 1) {
                return true;
            }
            // 只要有任意一个和基准不一样，校验失败
            const hasDiff = validList.some(item => {
                return item.check_payment_channel !== this.check_payment_channel;
            });

            if (hasDiff) {
                return false;
            }
            return true;
        },
        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            var flag = true;
            var producrList = this.$refs.productList.getData('selected');
            if(!producrList || producrList.length == 0){
                flag = false;
                this.$message({
                    message: '请至少选择一条选择需要提现的订单记录',  // 提示内容,
                    type: 'warn'
                });
                return false;
            }
            if (!this.validatePaymentChannel(producrList)){
                this.$message({
                    message: '只能请选择【支付渠道】完全相同的订单进行操作',  // 提示内容,
                    type: 'warn'
                });
                flag = false;
                return false;
            }
            if (flag){
                this.ids = producrList.map(item => item.id);
                //计算总计值
                this.orderCount = this.ids.length;
                //计算总计值
                this.withdrawAmount = producrList.reduce((sum, item) => {
                    const val = Number(item.check_receipt_money) || 0;
                    return sum + Math.round(val * 100);
                }, 0);
                this.globalDialog('cashWithdrawApplyConfirm', {
                    data:{
                        check_payment_channel:this.check_payment_channel,
                        ids:this.ids,
                        withdraw_amount:this.withdrawAmount
                    }
                }, next)
            }
        },

        open() {
            this.searchHandle();
            this.$refs.dialog.open({
                title: (this.withdraw_account_type==1?'【通联账户】':'【三方同售账户】')+'可提现订单列表'
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>